/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import ArrowUpward from '@mui/icons-material/ArrowUpward'
import ArrowDownward from '@mui/icons-material/ArrowDownward'

interface Props {
  canSort?: boolean
  isSorted?: boolean
  isSortedDesc?: boolean
}

const iconStyle = css`
  margin-left: 0.25rem;
  color: #b2b2b2;
  line-height: 0;

  && {
    font-size: 1rem;
  }
`
const smallIconStyle = css`
  ${iconStyle};
  && {
    font-size: 0.75rem;
  }
`
const wrapperStyle = css`
  line-height: 0;
  flex: none;
`
const stackedWrapperStyle = css`
  ${wrapperStyle};
  flex: none;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export default function SortIndicator({ canSort, isSorted, isSortedDesc }: Props) {
  if (!canSort) {
    return null
  }

  if (!isSorted) {
    return (
      <span css={stackedWrapperStyle}>
        <ArrowUpward css={smallIconStyle} />
        <ArrowDownward css={smallIconStyle} />
      </span>
    )
  }

  if (isSortedDesc) {
    return (
      <span css={wrapperStyle}>
        <ArrowDownward css={iconStyle} />
      </span>
    )
  }

  return (
    <span css={wrapperStyle}>
      <ArrowUpward css={iconStyle} />
    </span>
  )
}
